import { useParams } from 'react-router-dom';
import { useEmployeeUrl } from 'domain/shared/employee';
import { createRoute, useEntityUrl } from 'framework/routing';

const FINANCE_ID = 'compensationId';
const PATH = '/compensation';

export const CREATE_COMPENSATION_PACKAGE = 'CREATE_COMPENSATION_PACKAGE';
export const FE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGES = 'FE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGES';

export const useFinanceRoute = () => {
  return createRoute({
    listRoute: PATH,
    singleEntityRoute: `/:${FINANCE_ID}`,
  });
};

export const useFinanceUrl = () => {
  const { getSingleEntityUrl } = useEmployeeUrl();

  return useEntityUrl({
    baseLink: `${getSingleEntityUrl()}${PATH}`,
    idSource: FINANCE_ID,
  });
};

export const useFinanceId = () => useParams<Dictionary<string>>()[FINANCE_ID]!;
